<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-sys__user">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item>
                    <el-button v-if="$hasPermission('sys:org:save')" type="primary" @click="addOrUpdateHandle()">{{
                        $t('add') }}
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" row-key="id" border style="width: 100%;">
                <el-table-column prop="orgNo" :label="$t('org.orgNo')" sortable="custom" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="orgName" :label="$t('org.orgName')" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="orgType" :label="$t('org.orgType')" sortable="custom" header-align="center"
                                 align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.orgType === '1'" size="small">总部
                        </el-tag>
                        <el-tag v-else-if="scope.row.orgType === '2'" size="small" type="success">区域</el-tag>
                        <el-tag v-else size="small" type="success">公司</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" :label="$t('org.status')" sortable="custom" header-align="center"
                                 align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status === 0" size="small" type="danger">注销
                        </el-tag>
                        <el-tag v-else size="small" type="success">正常</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createDate" :label="$t('org.createDate')" sortable="custom"
                                 header-align="center" align="center" width="180"></el-table-column>
                <el-table-column prop="creator" :label="$t('org.creator')" sortable="custom"
                                 header-align="center" align="center" width="180"></el-table-column>

                <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button v-if="$hasPermission('sys:user:saveSubAdminSave') && scope.row.orgType !== '1'" type="text"
                                   size="small"
                                   @click="configSubAdminHandle(scope.row.id)">配置管理员
                        </el-button>
                        <el-button v-if="$hasPermission('sys:org:update') && scope.row.orgType !== '1'" type="text"
                                   size="small"
                                   @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
                        </el-button>
                        <el-button v-if="$hasPermission('sys:org:delete') && scope.row.orgType !== '1'" type="text"
                                   size="small"
                                   @click="deleteHandle(scope.row.id)">{{ $t('delete') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--<el-table
                    v-loading="dataListLoading"
                    :data="dataList"
                    border
                    @selection-change="dataListSelectionChangeHandle"
                    @sort-change="dataListSortChangeHandle"
                    style="width: 100%;">
                <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                <el-table-column prop="orgNo" :label="$t('org.orgNo')" sortable="custom" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="orgName" :label="$t('org.orgName')" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="orgType" :label="$t('org.orgType')" sortable="custom" header-align="center"
                                 align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status === 1" size="small">总公司
                        </el-tag>
                        <el-tag v-else-if="scope.row.status === 2" size="small" type="success">区域</el-tag>
                        <el-tag v-else size="small" type="success">公司</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" :label="$t('org.status')" sortable="custom" header-align="center"
                                 align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status === 0" size="small" type="danger">注销
                        </el-tag>
                        <el-tag v-else size="small" type="success">正常</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createDate" :label="$t('org.createDate')" sortable="custom"
                                 header-align="center" align="center" width="180"></el-table-column>
                <el-table-column prop="creator" :label="$t('org.creator')" sortable="custom"
                                 header-align="center" align="center" width="180"></el-table-column>

                <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button v-if="$hasPermission('sys:org:update')" type="text" size="small"
                                   @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
                        </el-button>
                        <el-button v-if="$hasPermission('sys:org:delete')" type="text" size="small"
                                   @click="deleteHandle(scope.row.id)">{{ $t('delete') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>-->
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
            <ConfigAdmin v-if="configAdminVisible" ref="ConfigAdmin"
                             @refreshDataList="getDataList"></ConfigAdmin>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module';
    import AddOrUpdate from './org-add-or-update'
    import ConfigAdmin from './org-config-admin'

    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                configAdminVisible:false,
                mixinViewModuleOptions: {
                    getDataListURL: '/sys/org/list',
                    deleteURL: '/sys/org'
                }
            }
        },
        methods:{
            configSubAdminHandle (id) {
                console.log(id)
                this.configAdminVisible=true
                this.$nextTick(() => {
                    this.$refs.ConfigAdmin.init(id)
                })
            },
        },
        components: {
            AddOrUpdate,
            ConfigAdmin
        }
    }
</script>

<style scoped>

</style>
